import React from 'react';
import { Link } from 'react-router-dom';
import AppSubmenu from './AppSubmenu';

const AppMenu = (props) => {
    return (
        <div className="layout-sidebar" onClick={props.onMenuClick}>
            <Link to="/" className="logo">
                <img id="app-logo" className="logo-image" src="https://dekkoisho.com/wp-content/uploads/2021/08/cropped-dekkoisho-icon-512x512-1-192x192.png" alt="Dekko-Isho-Group" />
                <span className="app-name">IT</span>
                <p style={{'verticalAlign': 'middle', 'fontSize': '1.2rem', 'letterSpacing': '1.1px', 'color': '#ffffff'}}>Asset Management</p>
            </Link>

            <div className="layout-menu-container">
                <AppSubmenu
                    items={props.model}
                    menuMode={props.menuMode}
                    parentMenuItemActive
                    menuActive={props.active}
                    mobileMenuActive={props.mobileMenuActive}
                    root
                    onMenuitemClick={props.onMenuitemClick}
                    onRootMenuitemClick={props.onRootMenuitemClick}
                />
            </div>
        </div>
    );
};

export default AppMenu;
